import React, { useState, Dispatch, SetStateAction } from 'react';
import { Row, Col } from 'react-bootstrap';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserCircle } from '@fortawesome/free-regular-svg-icons';
import { faPlusSquare } from '@fortawesome/free-solid-svg-icons';

import { NoResultsDetail } from 'components/Common';
import { AddButton, AddCard } from 'components/AddCard';
import { CloudUser } from 'types/cloud';
import UserCard from './UserCard';
import UserModal from './UserModal';
import UserPlaceholder from './UserPlaceholder';

interface IUsersProps {
  users: CloudUser[];
  cloud: string | number;
  setUsers: Dispatch<SetStateAction<CloudUser[]>>;
  userLoading: boolean;
}

const Users: React.FC<IUsersProps> = ({
  users,
  cloud,
  setUsers,
  userLoading,
}) => {
  const [addUser, setAddUser] = useState(false);

  return (
    <Row>
      {addUser && (
        <UserModal
          show={addUser}
          setShow={() => {
            setAddUser(false);
          }}
          cloud={cloud}
          setUsers={setUsers}
        />
      )}
      <Col xl="3" lg="4" sm="6" xs="12">
        <AddCard
          onClick={() => {
            setAddUser(true);
          }}
          width="100%"
          height="50px"
          style={{
            marginBottom: '12px',
          }}
        >
          <AddButton row>
            <FontAwesomeIcon icon={faPlusSquare} />
            <span>criar</span>
          </AddButton>
        </AddCard>
      </Col>
      {userLoading ? (
        <UserPlaceholder />
      ) : users.length ? (
        users.map(
          user =>
            user.username !== 'root' && (
              <Col key={user.id} xl="3" lg="4" sm="6" xs="12">
                <UserCard user={user} setUsers={setUsers} />
              </Col>
            ),
        )
      ) : (
        <NoResultsDetail row width="230px" height="50px">
          <FontAwesomeIcon icon={faUserCircle} />
          Nenhum usuário.
        </NoResultsDetail>
      )}
    </Row>
  );
};

export default Users;
